import styled from 'styled-components';

const TableCellWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export default TableCellWithIcon;
